import type { CategoryDefinition } from '@/types';

/** Blank-slate vertical: one holding category so the catalog is never empty. */
export const otherCategories: readonly CategoryDefinition[] = [
  { id: 'other.general', name: 'General', icon: 'package', color: 'slate', order: 1, description: 'Your services live here until you add categories' },
];
